module.exports = __webpack_public_path__ + "img/1.0012b22a.png";